import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-site-roles-picker .tb-select-site-role-menu', {
    margin: '7px 6px',
});

cssRule('.tb-site-roles-picker .tb-admin-checkbox', {
    height: '17px',
    marginLeft: '3px',
    bottom: 0,
    position: 'absolute',
});

cssRule('.tb-site-roles-picker .tb-admin-checkbox .tb-label', {
    marginLeft: '6px',
    cursor: 'pointer',
});

cssRule('.tb-site-roles-picker .tb-data-grid-headers-line', {
    borderTop: 'none',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
});

cssRule('.tb-site-roles-picker .tb-grid-container', {
    top: '52px',
    bottom: '29px',
    border: 'solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2') + ' 1px',
    overflowX: 'hidden',
});

cssRule('.tb-site-roles-picker .tb-scroll', {
    margin: '3px',
});

cssRule('.tb-site-roles-picker .tb-checkbox-cell', {
    paddingTop: '11px',
});

cssRule('.tb-site-roles-picker .tb-data-grid-cell, .tb-site-roles-picker .tb-data-grid-cell-text, .tb-site-roles-picker .tb-data-grid-row-background', {
    height: '37px',
    lineHeight: '37px',
    borderBottom: 'none',
});

cssRule('.tb-site-roles-picker .tb-search-panel', {
    position: 'absolute',
    left: '167px',
    right: 0,
});

cssRule('.tb-membership-search', {
    width: '100%',
});

cssRule('.tb-membership-search input', {
    width: '100%',
});

cssRule('.tb-picker-container', {
    position: 'relative',
    height: '200px',
    marginBottom: '34px',
});

cssRule('.tb-select-role-dropdown-container', {
    display: 'inline-block',
    width: '242px',
});

cssRule('.tb-site-role-column-header', {
    display: 'inline-block',
    width: '254px',
});

cssRule('.tb-site-role-permissions-popover', {
    position: 'absolute',
    top: '-41px',
    left: '10px',
});

cssRule('.tb-site-role-permissions-popover-tall', {
    position: 'absolute',
    top: '-35px',
    left: '10px',
});

cssRule('.tb-site-role-permissions-table', {
    borderCollapse: 'collapse',
    borderSpacing: 0,
});

cssRule('.tb-site-role-permissions-table td, .tb-site-role-permissions-table th', {
    padding: '6px',
});

cssRule('.tb-site-role-permissions-table .tb-site-role-permissions-table-divider', {
    borderTop: '1px solid ' + applyColor(DesignTokens.color.component.border.neutral.default.default, '#e1e1e1'),
});

cssRule('.tb-site-role-permissions-table .tb-license-role-header', {
    fontWeight: 'bold',
});

cssRule('.tb-site-role-permissions-table .tb-license-role-header > td', {
    paddingBottom: '0px',
    paddingLeft: '0px',
    paddingTop: '11px',
});

cssRule('.tb-site-role-permissions-table .tb-license-role-header + tr > td', {
    paddingTop: '3px',
});

cssRule('.tb-site-membership-filters', {
    position: 'relative',
    height: '22px',
    paddingBottom: '12px',
});

cssRule('.tb-site-membership-select', {
    display: 'inline-block',
    position: 'relative',
    paddingRight: '12px',
});

cssRule('.tb-site-membership-select .tb-popup-menu', {
    width: '155px',
});

cssRule('.tb-admin-site-role-permissions-container td, .tb-admin-site-role-permissions-container th', {
    padding: '6px',
});

